import { useEffect, useState } from "react";
import styled from "styled-components";

const LinkedInAuthScreen = () => {

   // ✅ get from RN
  const CLIENT_ID = "86sfmxd5369v9b";
  const REDIRECT_URI = "https://api1.pepchat.in/auth/linkedin/callback"; // Your backend endpoint
  const SCOPE = "openid profile";

  const linkedInAuthURL = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&scope=${SCOPE}`;

  const [loading ,setLoading] = useState(false);

  const handleLinkedInLogin = () => {
    window.location.href = linkedInAuthURL; // In Web
    setLoading(true);
  };



  // ✅ Listen for LinkedIn callback redirect (with code) on same page
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const status = params.get("status");
  const token = params.get("token");




  if (status === "100" && token) {
    // ✅ Send token back to React Native WebView
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ status: 100, token }));
    } else {
      // ✅ If opened in normal browser, redirect or show success
    //   window.location.href = "/success";
    }
  } else if (status) {
    // Send failure status to RN if present
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ status: Number(status) }));
    }
  }

  setLoading(false);
}, []);

return (
  <Container>
    {loading ? (
      <LoaderWrapper>
        <Spinner />
        <LoadingText>Redirecting to LinkedIn...</LoadingText>
      </LoaderWrapper>
    ) : (
      <Content>
        <LeftSection>
          <Tagline>Why LinkedIn?</Tagline>
          <Title>
            Verified Profiles, <ColoredText>Better Connections</ColoredText>
          </Title>
          <Description>
            We’re building a trusted community where genuine people connect.
            By verifying through LinkedIn, you help us keep fake profiles away
            and ensure meaningful interactions.
          </Description>
          <Points>
            <Point>✔ Quality people, authentic connections</Point>
            <Point>✔ Reduce fake names & spam accounts</Point>
            <Point>✔ Build a community of trust</Point>
          </Points>
          <Disclaimer>
            We do not store or access your LinkedIn data.  
            Verification is only for authenticity.
          </Disclaimer>

          <LinkedInButton onClick={handleLinkedInLogin} disabled={loading}>
            <img
              src="https://cdn-icons-png.flaticon.com/128/3991/3991775.png"
              alt="LinkedIn Logo"
              height={25}
              width={25}
            />
            Continue with LinkedIn
          </LinkedInButton>
        </LeftSection>

        <RightSection>
          <MessageWrapper>
            <ComingSoonMessage>
              👥 Help us create a professional & safe space
            </ComingSoonMessage>
            <SubMessage>LinkedIn login adds trust to your profile.</SubMessage>
          </MessageWrapper>
        </RightSection>
      </Content>
    )}
  </Container>
);
};

export default LinkedInAuthScreen;

// ✅ Styled Components remain unchanged
const Container = styled.div`
  background-color: #000;
  color: #fff;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 1200px;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

const LeftSection = styled.div`
  flex: 1;
`;

const Tagline = styled.p`
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
`;

const Title = styled.h1`
  font-size: 36px;
  line-height: 1.2;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    font-size: 48px;
  }
`;

const ColoredText = styled.span`
  background: linear-gradient(90deg, #0077b5, #00a0dc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
`;

const Points = styled.div`
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 20px;
`;

const Point = styled.p`
  margin: 5px 0;
`;

const Disclaimer = styled.p`
  font-size: 14px;
  color: #aaa;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const LinkedInButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0077b5;
  color: white;
  font-size: 18px;
  font-weight: 600;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  gap: 10px;

  &:hover {
    background-color: #005582;
  }
`;

const RightSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

const ComingSoonMessage = styled.h2`
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  color: #00a0dc;
`;

const SubMessage = styled.p`
  font-size: 16px;
  color: #aaa;
  text-align: center;
`;

const Spinner = styled.div`
  width: 18px;
  height: 18px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 10px;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 15px;
`;

const LoadingText = styled.p`
  font-size: 18px;
  color: #aaa;
`;